export * from './dashboard-detail.component';
export * from './dashboard-detail.component.module';